import { createFileRoute } from '@tanstack/react-router';
import { organizationCountsQuery, organizationsQuery } from '@/features/organizations/api';
import { OrganizationsPage } from '@/features/organizations/pages/OrganizationsPage';
import { organizationsSearchSchema } from '@/features/organizations/search';

export const Route = createFileRoute('/_authed/ops/organizations/')({
  staticData: { help: 'organizations' },
  validateSearch: organizationsSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(organizationsQuery(deps));
    void queryClient.prefetchQuery(organizationCountsQuery(deps.q));
  },
  component: OrganizationsPage,
});
